import script from "./NavbarDark.vue?vue&type=script&setup=true&lang=js"
export * from "./NavbarDark.vue?vue&type=script&setup=true&lang=js"

import "./NavbarDark.vue?vue&type=style&index=0&id=72aab76e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-72aab76e"]])

export default __exports__